//Checks to make sure a given string is is a valid hex code, returns null if not.

export const hexCodeFromText = (text: string) => {
    if (/^#[0-9a-fA-F]{6}$/.test(text)) {
        return text;
    } else if (/^#[0-9a-fA-F]{3}$/.test(text)) {
        return text.replace(/[0-9a-fA-F]{1}/g, `$&$&`);
    }
    return null;
}